var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisibilityIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.9974 5.66667C9.53716 5.66667 9.16406 5.29357 9.16406 4.83333C9.16406 4.3731 9.53716 4 9.9974 4H14.1641C14.6243 4 14.9974 4.3731 14.9974 4.83333V9C14.9974 9.46024 14.6243 9.83333 14.1641 9.83333C13.7038 9.83333 13.3307 9.46024 13.3307 9V6.84518L9.75332 10.4226C9.42788 10.748 8.90024 10.748 8.57481 10.4226L6.66406 8.51184L3.08665 12.0893C2.76121 12.4147 2.23358 12.4147 1.90814 12.0893C1.5827 11.7638 1.5827 11.2362 1.90814 10.9107L6.07481 6.74408C6.40024 6.41864 6.92788 6.41864 7.25332 6.74408L9.16406 8.65482L12.1522 5.66667H9.9974Z",
    fill: "#399D81"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibilityIcon);
export default __webpack_public_path__ + "static/media/visibility-icon.af7bf97201968601b4b707d87c73d743.svg";
export { ForwardRef as ReactComponent };